import React, { useEffect, useState } from 'react';
import { Column, Direction, Grid, Margin, Card, IconAlert, IconChevronRight } from '@scotia/canvas-react';
import { ContentHeightMonitor } from '@cldf/scotiaweb-canvas-react';
import RealTimeOffer from 'rto-spl-web-cl';
import { getAllInSession } from '@cldf/scotiaweb-customer-information';
import { MercuryGroup, MercuryZone } from 'mercury-react-sdk';
import { CustomerWellcomeCard } from '../../components/wellcome';
import { Shortcuts } from '../../components/shortcuts';
import { OnlineCourse } from '../../components/online-course';
import { BasicShowCase } from '../../components/basic-showcase';
import styles from './Position.scss';
import '@cldf/canvas-core-react-develop/lib/CanvasStyles.css';
import { getMercurySettings, getClientRut } from '../../services/service.parameters';
import Carousel from '../../components/carousel';
import ProductsTab from '../../components/products-tab';
import { getUserPendingProducts } from '../../services/api/api.services';

import AlertBanner from '../../components/banner-pending/AlertBanner';
import StatusBadge from '../../components/banner-pending/components/status-badge/StatusBadge';
import { getClientKyc } from '../../services';
import { navigate } from '../../services/web.navigation';
/**
 * Delete the height definitions of the divs while including real elements (heigh is based on Sketch design)
 */

const IS_CURSE_ONLINE = 'isCurseOnline';
export const Position = () => {
  sessionStorage.removeItem(IS_CURSE_ONLINE);
  const [showBanner, setShowBanner] = useState(false);
  const [showPendingBanner, setShowPendingBanner] = useState(false);
  const [listPendings, setListPendings] = useState([]);
  const [isCurseOnline, setIsCurseOnline] = useState(true);
  const [mercuryEnabled, setMercuryEnabled] = useState(undefined);
  const [mercuryApi, setMercuryApi] = useState();
  const [renderersLocation, setRenderersLocation] = useState();
  const [clientRut, setClientRut] = useState(null);
  const [clientName, setClientName] = useState('');
  const [showKYCBanner, setShowKYCBanner] = useState(false);

  /* istanbul ignore next */
  const getSession = async () => {
    const session = await getAllInSession();
    const { mercuryApiUrl, mercuryRenderersUrl } = await getMercurySettings();
    setClientName(session.SESSION.nombre);
    setShowBanner(session.T26000 !== undefined);
    setMercuryEnabled(session.TGLMER !== undefined);
    setMercuryApi(mercuryApiUrl);
    setRenderersLocation(mercuryRenderersUrl);
  };

  const getItemCurseOnline = () => {
    const curseOnline = sessionStorage.getItem(IS_CURSE_ONLINE);
    if (curseOnline !== null) {
      /* istanbul ignore next */
      setIsCurseOnline(JSON.parse(curseOnline));
    }
  };
  const validateKYC = async () => {
    const response = await getClientKyc();
    setShowKYCBanner(response);
  };
  const moveToKyc = () => {
    navigate('#mfe/mfe-kyc-web-cl/');
  };

  useEffect(() => {
    validateKYC();
    getSession();
    getItemCurseOnline();
  }, [isCurseOnline]);

  useEffect(() => {
    getClientRut()
      .then(_rut => setClientRut(_rut))
      // eslint-disable-next-line no-console
      .catch(error => console.log(error));

    getUserPendingProducts()
      .then(data => {
        setListPendings(data);

        if (data.length) setShowPendingBanner(true);
      })
      // eslint-disable-next-line no-console
      .catch(error => console.log(error));
  }, []);

  const TOKEN_URL = '/cgi-bin/transac/dotrxajax?TMPL=/security/passport.json&intends=';
  const getPendingExpierationDays = arrListPendings => {
    const expirationDays =
      arrListPendings.length === 1
        ? arrListPendings[0].days_left
        : Math.min(...arrListPendings.map(item => item.days_left));
    return `VENCE EN ${expirationDays} DÍAS`;
  };

  return (
    <ContentHeightMonitor>
      {mercuryApi !== undefined && (
        <MercuryGroup
          apiUrl={mercuryApi}
          tokenUrl={TOKEN_URL}
          renderersUrl={renderersLocation}
          id="home_itt_sweb"
          withEventstream={false}
          tokenExpireTime={40000}
        >
          <MercuryZone id="home_itt" />
        </MercuryGroup>
      )}
      <Grid style={{ margin: '0 auto' }}>
        <Direction>
          <Column id={'alert-banner'} xs={12} sm={12} md={10} mdOffset={1} lg={10}>
            <BasicShowCase
              id="alert-banner-container"
              htmlURL="/mfe-intelligent-offer-provider-web-cl"
              classNames={''}
              style={{
                marginBottom: '0px',
                border: 'none',
                width: '100%',
                display: 'block',
              }}
            />
          </Column>
          {mercuryApi !== undefined && (
            <MercuryGroup
              apiUrl={mercuryApi}
              tokenUrl={TOKEN_URL}
              renderersUrl={renderersLocation}
              id="home_sweb"
              withEventstream={false}
              tokenExpireTime={40000}
              interactionEnabled={mercuryEnabled}
            >
              <Column
                id={'main-content-body'}
                className={styles['main-content-container']}
                xs={12}
                sm={12}
                md={10}
                lg={7}
                lgOffset={1}
                mdOffset={1}
              >
                <Margin xs={24} md={36}>
                  {showKYCBanner && (
                    <Column id={'kyc-banner'} xs={12} md={12}>
                      <Margin side="both" lg={12} md={12} sm={12} xs={12}>
                        <div className={styles['banner-kyc']} onClick={moveToKyc}>
                          <div className={styles['banner-kyc--alert-icon']}>
                            <IconAlert size={24} />
                          </div>
                          <div className={styles['banner-kyc--text']}>
                            <h3>Es importante que mantengas tus datos al día. Actualízalos aquí</h3>
                          </div>
                          <div className={styles['banner-kyc--follow-icon']}>
                            <IconChevronRight size={24} />
                          </div>
                        </div>
                      </Margin>
                    </Column>
                  )}
                  <Direction>
                    {showPendingBanner && listPendings.length ? (
                      <Column xs={12} sm={12} md={12} lg={12}>
                        <Margin xs={18} sm={18} md={18} lg={18} side={'bottom'} style={{ position: 'relative' }}>
                          <StatusBadge type="error">{getPendingExpierationDays(listPendings)}</StatusBadge>
                          <AlertBanner
                            redirectTo={
                              listPendings.length > 1 ? '/mfe-pending-product-web-cl' : listPendings[0].hyperlink_ref
                            }
                            title={
                              listPendings.length > 1
                                ? `${clientName}, tiene(s) propuesta(s) por confirmar. Revísalos aquí`
                                : `${clientName}, ${listPendings[0].title}`
                            }
                            closeButton={{
                              label: 'Cerrar',
                              onClick: () => setShowPendingBanner(false),
                            }}
                          />
                        </Margin>
                      </Column>
                    ) : null}
                    <Column id={'wellcome-card-container'} md={12} className={'hide--xs hide--sm'}>
                      {/* The Wellcome Card */}
                      <CustomerWellcomeCard />
                    </Column>
                    <Column id={'main-body-shortcuts-container'} xs={12} md={12} className={'hide--md hide--lg'}>
                      {clientRut && (
                        <Card style={{ padding: '2.4rem' }}>
                          <Shortcuts rut={clientRut} />
                        </Card>
                      )}
                    </Column>
                    <Column id={'main-body-marketing-1-container'} xs={12} md={12}>
                      {/* Marketing */}
                      <Margin side="both" lg={12} md={12} sm={12} xs={12}>
                        <MercuryZone id="banner_main" />
                      </Margin>
                    </Column>
                    <Column id={'main-body-online_course-container'} xs={12} md={12}>
                      {/* Online Course */}
                      <OnlineCourse
                        htmlURL={'/mfe-onlinecourse-web-cl/GetMessageHome/index2.html'}
                        callback={() => {
                          /* istanbul ignore next */
                          getItemCurseOnline();
                        }}
                      />
                    </Column>
                    {showBanner && !isCurseOnline && (
                      <Column id={'realtime-card-container'} md={12} sm={12} xs={12}>
                        <Margin side="top" xs={24} sm={24} md={24}>
                          <RealTimeOffer locationParam="HOME" />
                        </Margin>
                      </Column>
                    )}

                    <Column id={'main-body-summary-container'} xs={12} md={12}>
                      <Margin side={'top'} xs={24} sm={24} md={24}>
                        <ProductsTab loadProductsCallback={getUserPendingProducts} />
                      </Margin>
                    </Column>
                  </Direction>
                </Margin>
              </Column>

              <Column
                id={'side-content-body'}
                lg={3}
                className={'hide--md hide--xs hide--sm'}
                style={{ padding: '0', marginTop: '36px' }}
              >
                <>
                  <Column xs={12} md={12} lg={12}>
                    <div>
                      <MercuryZone id="side_top" />
                    </div>
                  </Column>
                  <Column xs={12} md={12} lg={12}>
                    <Margin xs={24} sm={24} md={24} lg={24}>
                      <MercuryZone id="side_bottom" />
                    </Margin>
                  </Column>

                  <Column xs={12} md={12} lg={12}>
                    <Margin xs={24} sm={24} md={24} lg={24}>
                      <Carousel width={324}>
                        <MercuryZone id="carousel_1" />

                        <MercuryZone id="carousel_2" />

                        <MercuryZone id="carousel_3" />

                        <MercuryZone id="carousel_4" />

                        <MercuryZone id="carousel_5" />
                      </Carousel>
                    </Margin>
                  </Column>
                  <MercuryZone id="home_modal" />
                </>
              </Column>
            </MercuryGroup>
          )}
          {mercuryApi !== undefined && (
            <>
              <Column lg={3} />
              <Column lg={3} />
              <Column lg={2} />
              <Column lg={3} className={'hide--md hide--xs hide--sm'} style={{ padding: '0', marginTop: '-25px' }}>
                <Column xs={12} md={12} lg={12}>
                  <Margin xs={24} sm={24} md={24} lg={24}>
                    <MercuryGroup
                      apiUrl={mercuryApi}
                      tokenUrl={'/cgi-bin/transac/dotrxajax?TMPL=/security/passport.json&intends='}
                      renderersUrl={renderersLocation}
                      id="scotialevels_join_to"
                      withEventstream={false}
                      tokenExpireTime={40000}
                      interactionEnabled={mercuryEnabled}
                    >
                      <MercuryZone id="sl_zone_join_to" />
                    </MercuryGroup>
                  </Margin>
                </Column>
              </Column>
            </>
          )}
        </Direction>
      </Grid>
    </ContentHeightMonitor>
  );
};
